import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Api from '../../Config/Api';
import MasterApi from '../../Config/MasterApi';


export const getOtpLogin = createAsyncThunk('OTP/loginOTP', async (data) => {
    return Api.post(Api.routeHelper+MasterApi.otpLogin, data)
        .then(response => {
            return response
        })
        .catch(err => {
            return err
        })
})

export const getOtpVerif =createAsyncThunk('OTP/verifOTP', async(data)=>{
    return Api.post(Api.routeHelper+MasterApi.otpVerif, data)
    .then(response=>{
        return response
    }).catch(err=>{
        return err
    })
})

export const getOtpGenerate = createAsyncThunk('/OTP/generateOTP', async (data) => {
    return Api.post(Api.routeHelper+MasterApi.otpGenerate, data)
        .then(response => {
            return response
        }).catch(err => {
            return err
        })
})

export const getParameterApps = createAsyncThunk('/OTP/Parameter', async () => {
    return Api.get(Api.routeHelper+MasterApi.getParameter)
        .then(response => {
            return response
        })
        .catch(err => {
            return err
        })
})

export const getCitySign = createAsyncThunk('/Sign/City', async () => {
    return Api.get(Api.routeHelper+MasterApi.getCitySign)
        .then(response => {
            return response
        })
        .catch(err => {
            return err
        })
})


export const logOut = createAsyncThunk('/logOut/Out', async (data) => {
    return Api.post(Api.routeHelper+MasterApi.LogOut, data)
        .then(response => {
            return response
        })
        .catch(err => {
            return err
        })
})

const ParameterApps = createSlice(({
    name: "Parameter",
    initialState: {
        Parameter: []
    },
    extraReducers: {
        [getParameterApps.fulfilled]: (state, action) => {
            state.Parameter = action.payload.data
        }
    }
}))

export const CitySign = createSlice(({
    name: "CitySign",
    initialState: {
        CitySign: []
    },
    extraReducers: {
        [getCitySign.fulfilled]: (state, action) => {
            const transformedData = action.payload.data.map(item => ({
                label: item.description1,
                value: item.description1,
                key: item.description1
            }));
            state.CitySign = transformedData;
        }
    }
}))


export const DeviceId = createSlice(({
    name:"OTP",
    initialState:{
        DeviceId:[]
    },
    extraReducers: {
        [getOtpLogin.fulfilled]: (state, action) => {
            state.DeviceId = action.payload.data
        }
    }
}))

export default ParameterApps.reducer